import { render, staticRenderFns } from "./Linkdialog.vue?vue&type=template&id=1942a192&scoped=true"
import script from "./Linkdialog.vue?vue&type=script&lang=js"
export * from "./Linkdialog.vue?vue&type=script&lang=js"
import style0 from "./Linkdialog.vue?vue&type=style&index=0&id=1942a192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942a192",
  null
  
)

export default component.exports